import React from 'react';
import styled from "styled-components";

type ErrorMessageProps = {
    bodyText?: string;
}

function ErrorMessage({bodyText}: ErrorMessageProps) {

    const PromptContainer = styled.div`
        padding-top:20px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    `;
    const NotFoundPrompt = styled.div`
        text-align:center;
        padding:20px;
        color: var(--main-grey-color);
    `;
    const BoldText = styled.p`
        font-family: Lato-Bold;
        font-size:2rem;
    `;

    const BodyText = styled.p`
        font-family: Lato-Regular;
        font-size:1.6rem;
    `;


    return (
        <PromptContainer>
            <NotFoundPrompt>
                <BoldText>Sorry, we encountered a problem</BoldText>
                {bodyText && <BodyText>{bodyText}</BodyText>}
            </NotFoundPrompt>
        </PromptContainer>
    );
}
export default ErrorMessage;

